import { formatHours } from "@/components/prospect/prospect.util";
import { WARNINGS, WEEKDAYS } from "./trip-constants";

// Leitura do plano no editor de roteiro: plano e erro de cada equipe, dia, visitas, trechos e textos da agenda. Sem efeitos colaterais.
// Mixin do ProspectTripEditor: usa o estado dele (trip, form, teams, stops...).
export default {
    methods: {
        formatHoursText(hours) {
            return formatHours((Number(hours) || 0) * 60);
        },

        warningLabel(key) {
            return WARNINGS[key] || key;
        },

        // Plano
        planEntry(team) {
            if (!this.trip || !this.trip.plan || !team.id) return null;
            return (this.trip.plan.teams || []).find((entry) => entry.team_id === team.id) || null;
        },

        planOf(team) {
            const entry = this.planEntry(team);
            return entry ? entry.plan : null;
        },

        errorOf(team) {
            if (this.trip && this.trip.plan && this.trip.plan.error) return this.trip.plan.error;
            const entry = this.planEntry(team);
            return entry ? entry.error : null;
        },

        countOf(team) {
            return this.stops.filter((stop) => stop.team_key === team.key).length;
        },

        dayOf(team, index) {
            const plan = this.planOf(team);
            return plan ? plan.days.find((day) => day.index === index) || null : null;
        },

        // Listas arrastaveis a partir do plano; casos recem-incluidos aparecem
        // no fim ate o proximo calculo.
        rebuildLists() {
            const orderLists = {};
            const dayLists = {};
            this.teams.forEach((team) => {
                const own = this.stops.filter((stop) => stop.team_key === team.key).map((stop) => stop.case_id);
                const plan = this.planOf(team);
                const planned = plan ? plan.case_order.filter((id) => own.includes(id)) : [];
                orderLists[team.key] = [...planned, ...own.filter((id) => !planned.includes(id))];
                const days = plan ? plan.days.map((day) => day.events.filter((event) => event.type === "visit" && own.includes(event.case.id)).map((event) => event.case.id)) : [];
                if (plan) days.push([]); // espaco para criar o dia seguinte
                dayLists[team.key] = days;
            });
            this.orderLists = orderLists;
            this.dayLists = dayLists;
        },

        stopOf(caseId) {
            return this.stopByCase.get(caseId) || null;
        },

        inTrip(caseId) {
            return this.stopByCase.has(caseId);
        },

        caseName(caseId) {
            const item = this.caseIndex.get(caseId);
            return item ? item.company_name : `Caso ${caseId}`;
        },

        caseCity(caseId) {
            const item = this.caseIndex.get(caseId);
            return item && item.municipality ? `${item.municipality.name}/${item.municipality.uf}` : "município a definir";
        },

        otherTrips(item) {
            return (item.trips || []).filter((other) => other.id !== this.id);
        },

        visitTime(caseId) {
            const visit = this.visitIndex.get(caseId);
            return visit ? `${visit.start}–${visit.end}` : "—";
        },

        warningsOf(caseId) {
            const visit = this.visitIndex.get(caseId);
            return visit ? visit.warnings || [] : [];
        },

        legText(leg) {
            if (!leg) return "";
            return `${leg.estimated ? "≈ " : ""}${leg.km.toLocaleString("pt-BR")} km · ${formatHours(leg.minutes)}`;
        },

        // Trecho que chega na parada (so quando muda de cidade).
        legBefore(team, index) {
            const plan = this.planOf(team);
            const list = this.orderLists[team.key] || [];
            if (!plan || list.join(",") !== plan.case_order.join(",")) return "";
            const cityOf = (caseId) => {
                const item = this.caseIndex.get(caseId);
                return item && item.municipality ? item.municipality.id : null;
            };
            let previous = plan.base.id;
            let legIndex = -1;
            for (let i = 0; i <= index; i += 1) {
                const city = cityOf(list[i]);
                if (city !== previous) {
                    legIndex += 1;
                    previous = city;
                }
                if (i === index) return city !== (i ? cityOf(list[i - 1]) : plan.base.id) ? `${this.legText(plan.legs[legIndex])} desde ${plan.legs[legIndex] ? plan.legs[legIndex].from.name : ""}` : "";
            }
            return "";
        },

        // Volta a base; se a ultima visita ja e na base, o trecho aparece nela.
        returnText(team) {
            const plan = this.planOf(team);
            const list = this.orderLists[team.key] || [];
            const last = list.length ? this.caseIndex.get(list[list.length - 1]) : null;
            if (!plan || (last && last.municipality && last.municipality.id === plan.base.id)) return "";
            return this.legText(plan.legs[plan.legs.length - 1]);
        },

        driveText(team, index) {
            const day = this.dayOf(team, index);
            if (!day || day.idle) return "";
            const drives = day.events.filter((event) => event.type === "drive");
            if (!drives.length) return "";
            return `Estrada: ${drives.map((event) => `${event.start}–${event.end} ${event.from ? event.from.name : "parada"} → ${event.to.name}${event.partial ? " (parte)" : ""} (${event.estimated ? "≈ " : ""}${event.km.toLocaleString("pt-BR")} km)`).join(" · ")}`;
        },

        endText(day) {
            if (day.end.on_road_to) return `Pernoite na estrada, a ≈ ${day.end.km_left} km de ${day.end.on_road_to.name}`;
            return day.end.at_base ? `Fim em ${day.end.city.name}` : `Pernoite: ${day.end.city.name}`;
        },

        dayDate(offset) {
            if (!this.form.start_date) return "";
            const date = new Date(`${this.form.start_date}T12:00:00`);
            date.setDate(date.getDate() + offset);
            return `${WEEKDAYS[date.getDay()]}, ${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;
        },

        memberNames(team) {
            return team.member_ids.map((id) => (this.admins.find((person) => person.id === id) || {}).name).filter(Boolean).join(", ");
        },
    },
};
